import {Stack, Typography} from '@mui/material';
import * as Sentry from '@sentry/react';
import {Storage} from 'aws-amplify';
import React, {useCallback, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {
  PropertyFileUploader,
  UploadFile,
} from '../components/PropertyFileUploader';
import {
  PropertyRegistrationFormWithOcr,
  PropertyRegistrationWithOcrType,
} from '../components/PropertyRegistrationFormWithOcr';
import {executeLambdaFnUrl} from '../utils/executeLambdaFnUrl';

export const AddPropertyWithOcrScreen = () => {
  const navigate = useNavigate();
  const [uploadFiles, setUploadFiles] = useState<UploadFile[]>([]);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [data, setData] = useState<PropertyRegistrationWithOcrType>();
  const onAnalyze = useCallback(async () => {
    setIsAnalyzing(true);
    try {
      const objectKeys = await Promise.all(
        uploadFiles.map(async file => {
          const {key} = await Storage.put(
            `analyze-property/${encodeURIComponent(file.data.name)}`,
            file.data,
            {
              level: 'private',
              contentType: file.data.type,
            },
          );
          return key;
        }),
      );
      const {data} = await executeLambdaFnUrl<{
        data: PropertyRegistrationWithOcrType;
      }>({
        fnUrl: process.env.REACT_APP_ANALYZE_REAL_ESTATE_FN_URL ?? '',
        body: {
          objectKeys,
        },
      });
      setData(data);
    } catch (error) {
      Sentry.captureException(error);
      navigate('/error');
    }
    setIsAnalyzing(false);
  }, [navigate, uploadFiles]);
  return (
    <>
      <Typography
        sx={{fontSize: '24px', margin: '0 0 24px 0', fontWeight: '700'}}>
        物件情報の追加
      </Typography>
      <Stack direction="row" spacing={5}>
        <PropertyFileUploader
          files={uploadFiles}
          onChangeFiles={files => setUploadFiles(files)}
          onAnalyze={onAnalyze}
          isAnalyzing={isAnalyzing}
        />
        {data && (
          <PropertyRegistrationFormWithOcr
            isAnalyzing={isAnalyzing}
            data={data}
          />
        )}
      </Stack>
    </>
  );
};
